import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getWebtoolsSourceToken;

export const getWebtools = ({
  token,
  limit,
  language = "fr",
  communityId,
  filter,
  offset = 0,
  sourceToken = null
}) => {
  getWebtoolsSourceToken = updateSourceToken(
    getWebtoolsSourceToken,
    sourceToken
  );
  const filters = [
    {
      property: "organization.id",
      value: communityId,
      operator: "eq"
    }
  ];
  if (filter.categoryId) {
    filters.push({
      property: "category.id",
      value: filter.categoryId,
      operator: "eq"
    });
  }

  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];
  const fields = ["*", "creator", "tags", "organization", "social", "category"];
  const requestUrl = `${TTP_API_URL}/media/webtool`;

  return axios
    .get(requestUrl, {
      cancelToken: getWebtoolsSourceToken.token,
      params: {
        access_token: token,
        filter: JSON.stringify(filters),
        fields: fields.join(","),
        sort: JSON.stringify(sort),
        limit: 200,
        start: 0 //offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getWebtoolsFavorites = ({
  token,
  limit,
  offset = 0,
  language = "fr",
  community,
  filter,
  sourceToken = null
}) => {
  const filters = [
    {
      property: "organization.id",
      value: community,
      operator: "eq"
    }
  ];
  if (filter.categoryId) {
    filters.push({
      property: "category.id",
      value: filter.categoryId,
      operator: "eq"
    });
  }

  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];
  const fields = ["*", "creator", "organization", "category", "tags"];
  const requestUrl = `${TTP_API_URL}/media/webtool/favorites`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        filter: JSON.stringify(filters),
        sort: JSON.stringify(sort),
        fields: fields.join(","),
        limit: 200,
        start: 0 //offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getWebtoolsCategories = ({ token }) => {
  const requestUrl = `${TTP_API_URL}/media/category`;

  const filter = [{ property: "type", value: "WEBTOOL", operator: "like" }];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter)
    }
  });
};



// WEBPACK FOOTER //
// ./src/api/webtool.js